import { render, staticRenderFns } from "./HeaderPlaceDetail.vue?vue&type=template&id=63578a0f&"
import script from "./HeaderPlaceDetail.vue?vue&type=script&lang=js&"
export * from "./HeaderPlaceDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports